module.exports = __webpack_public_path__ + "public/assets/img/login-v2-dark.58db2eaf.svg";